import axios from 'axios';

import {
  AdminApi,
  AuthApi,
  CompaniesApi,
  CompanyUsageApi,
  DocumentApi,
  EmailApi,
  UsagesApi,
  UsersApi,
} from '../generated-api';

const options = {
  isJsonMime: (mime: string) => mime === 'application/json',
  headers: {
    'Content-Type': 'application/json',
  },
};
let axiosInterceptorId = 0;

const endpoint = process.env.REACT_APP_API_ENDPOINT;

export const apiClientRaw = axios.create();

initAxiosInterceptor();

export const adminApi = new AdminApi(options, endpoint, apiClientRaw);

export const authApi = new AuthApi(options, endpoint, apiClientRaw);

export const usersApi = new UsersApi(options, endpoint, apiClientRaw);

export const documentApi = new DocumentApi(options, endpoint, apiClientRaw);

export const companiesApi = new CompaniesApi(options, endpoint, apiClientRaw);

export const companyUsageApi = new CompanyUsageApi(options, endpoint, apiClientRaw);

export const usageApi = new UsagesApi(options, endpoint, apiClientRaw);

export const emailApi = new EmailApi(options, endpoint, apiClientRaw);

function initAxiosInterceptor(): void {
  if (axiosInterceptorId !== 0) {
    return;
  }
  axiosInterceptorId = apiClientRaw.interceptors.request.use((req) => {
    if (!req.url?.endsWith('/auth/login')) {
      const token = localStorage.getItem('token');
      req.headers['Authorization'] = `Bearer ${token}`;
    }
    return req;
  });

  apiClientRaw.interceptors.response.use(
    (res) => res,
    (error) => {
      if (axios.isAxiosError(error) && error.response?.status == 401 && window.location.pathname !== '/login') {
        if (!localStorage.getItem('token')) {
          return Promise.reject(error);
        }
        window.alert('タイムアウトしました。\n再ログインしてください。');
        localStorage.removeItem('token');
        window.location.replace('/login');
        return Promise.reject(error);
      }
      return Promise.reject(error);
    }
  );
}
